// extracted by mini-css-extract-plugin
module.exports = {"tender-list":"tenderList_tender-list__2khLZ","tender-list-title":"tenderList_tender-list-title__1Z4Ur","container":"tenderList_container__6_XJs"};